/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const Spinner = (props) => {
    const { className } = props;
    const centerPoint = '50 50';
    const viewBox = '100 100';
    return (
        <SvgIcon className={className} viewBox={`0 0 ${viewBox}`}>
            <g transform={`rotate(0 ${centerPoint})`}>
                <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#7C7C7D">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.9166666666666666s" repeatCount="indefinite" />
                </rect>
            </g>
            <g transform={`rotate(30 ${centerPoint})`}>
                <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#7C7C7D">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.8333333333333334s" repeatCount="indefinite" />
                </rect>
            </g>
            <g transform={`rotate(60 ${centerPoint})`}>
                <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#7C7C7D">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite" />
                </rect>
            </g>
            <g transform={`rotate(90 ${centerPoint})`}>
                <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#7C7C7D">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.6666666666666666s" repeatCount="indefinite" />
                </rect>
            </g>
            <g transform={`rotate(120 ${centerPoint})`}>
                <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#7C7C7D">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5833333333333334s" repeatCount="indefinite" />
                </rect>
            </g>
            <g transform={`rotate(150 ${centerPoint})`}>
                <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#7C7C7D">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite" />
                </rect>
            </g>
            <g transform={`rotate(180 ${centerPoint})`}>
                <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#7C7C7D">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.4166666666666667s" repeatCount="indefinite" />
                </rect>
            </g>
            <g transform={`rotate(210 ${centerPoint})`}>
                <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#7C7C7D">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.3333333333333333s" repeatCount="indefinite" />
                </rect>
            </g>
            <g transform={`rotate(240 ${centerPoint})`}>
                <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#7C7C7D">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite" />
                </rect>
            </g>
            <g transform={`rotate(270 ${centerPoint})`}>
                <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#7C7C7D">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.16666666666666666s" repeatCount="indefinite" />
                </rect>
            </g>
            <g transform={`rotate(300 ${centerPoint})`}>
                <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#7C7C7D">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.08333333333333333s" repeatCount="indefinite" />
                </rect>
            </g>
            <g transform={`rotate(330 ${centerPoint})`}>
                <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#7C7C7D">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite" />
                </rect>
            </g>
        </SvgIcon>
    );
};

Spinner.defaultProps = {
    className: '',
};

Spinner.propTypes = {
    className: PropTypes.string,
};

export default Spinner;
